import { vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderList as _renderList, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "dt-card signage__container" }
const _hoisted_2 = { class: "dt-card__heading-content" }
const _hoisted_3 = { class: "dt-card__heading-title float-start" }
const _hoisted_4 = {
  ref: "signageDetailsBody",
  class: "dt-card__body"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", {
  id: "layoutPreview",
  tabindex: "-1"
}, "Preview", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "* This preview approximates the final layout.", -1)
const _hoisted_7 = { class: "preview" }
const _hoisted_8 = { class: "layout-preview" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h2", null, "Global Colors", -1)
const _hoisted_12 = { class: "d-flex flex-wrap mb-3 mt-2" }
const _hoisted_13 = { class: "color-picker-group me-5" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", null, "Background Color", -1)
const _hoisted_15 = { class: "color-picker-group me-5" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", null, "Border Color", -1)
const _hoisted_17 = { class: "color-picker-group me-5" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", null, "Font Color", -1)
const _hoisted_19 = ["id"]
const _hoisted_20 = { class: "w-100" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = {
  key: 0,
  class: "signage-layout__zone-select col-sm-9"
}
const _hoisted_23 = { key: 0 }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = {
  key: 1,
  class: "signage-layout__zone-select col-sm-9"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2 mt-2" }, "This zone displays signage list items.", -1)
const _hoisted_27 = {
  key: 0,
  class: "mt-3"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("h3", null, "Signage Lists Using This Layout:", -1)
const _hoisted_29 = { class: "zone-type__zone-top-button col-sm-3" }
const _hoisted_30 = {
  key: 0,
  class: "row"
}
const _hoisted_31 = { class: "col-sm-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("h2", null, "Colors", -1)
const _hoisted_33 = { class: "d-flex flex-wrap" }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "draggable-modal__container" }
const _hoisted_36 = { class: "draggable-modal__preview" }
const _hoisted_37 = { class: "draggable-modal__fs-overlay" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("h2", { class: "m-0" }, "Warning", -1)
const _hoisted_39 = { class: "el-dialog__sub-title" }
const _hoisted_40 = { class: "list-unstyled d-flex flex-column gap-1 p-1 m-0" }
const _hoisted_41 = { class: "d-flex align-items-center gap-3" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("p", { class: "m-0 flex-grow-1" }, "Some of the selected signage lists already have layouts. Assigning a new layout will replace their existing layouts. Continue?", -1)
const _hoisted_43 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_Icon = _resolveComponent("Icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_SignageLayoutPreview = _resolveComponent("SignageLayoutPreview")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_color_picker = _resolveComponent("el-color-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_DraggableModal = _resolveComponent("DraggableModal")!
  const _component_Lightbox = _resolveComponent("Lightbox")!
  const _component_SignageListAssignmentModal = _resolveComponent("SignageListAssignmentModal")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_scroll_shadow = _resolveDirective("scroll-shadow")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({'dt-card__heading'  : _ctx.windowWidth.value >= 576 })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: _ctx.signageLayout.name,
            placement: "bottom-start",
            "show-after": 500,
            "hide-after": 0,
            disabled: _ctx.isEditingName
          }, {
            default: _withCtx(() => [
              _createElementVNode("h2", _hoisted_3, [
                (_ctx.isEditingName)
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      class: "dt-inline-input",
                      ref: "editItemNameInput",
                      onBlur: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isEditingName = false)),
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.signageLayout.name) = $event)),
                      onFocus: _cache[2] || (_cache[2] = ($event: any) => ($event.target.select()))
                    }, null, 544)), [
                      [_vModelText, _ctx.signageLayout.name]
                    ])
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createTextVNode(_toDisplayString(_ctx.signageLayout.name), 1)
                    ], 64))
              ])
            ]),
            _: 1
          }, 8, ["content", "disabled"]),
          _createVNode(_component_el_tooltip, {
            effect: "dark",
            content: "Rename",
            placement: "bottom",
            "show-after": 500,
            "hide-after": 0
          }, {
            default: _withCtx(() => [
              _createVNode(_component_Icon, {
                onClick: _ctx.toggleEditNameInput,
                class: "signage__item-rename",
                icon: _ctx.mdiPencil
              }, null, 8, ["onClick", "icon"])
            ]),
            _: 1
          })
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass({'mt-3 text-end' : _ctx.windowWidth.value < 576 })
      }, [
        _createVNode(_component_router_link, { to: '/signage/layouts' }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, { class: "ms-3" }, {
              default: _withCtx(() => [
                _createTextVNode("Back")
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.hasChanges)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "ms-3",
              type: "primary",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onReset(null)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Undo Changes")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_button, {
          id: "saveLayoutButton",
          class: "ms-3",
          type: "primary",
          onClick: _ctx.onSubmit
        }, {
          default: _withCtx(() => [
            _createTextVNode("Save Layout")
          ]),
          _: 1
        }, 8, ["onClick"])
      ], 2)
    ], 2),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _hoisted_5,
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_ctx.signageLayout)
              ? (_openBlock(), _createBlock(_component_SignageLayoutPreview, {
                  key: 0,
                  style: {"transform":"scale(0.5)","transform-origin":"top left"},
                  signageLayout: _ctx.signageLayout,
                  showEdit: true,
                  onZoneFocus: _ctx.zoneFocus
                }, null, 8, ["signageLayout", "onZoneFocus"]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createVNode(_component_el_button, {
          type: "primary",
          plain: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isPopoutPreviewVisible = !_ctx.isPopoutPreviewVisible))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Icon, {
              class: "me-2",
              icon: _ctx.mdiOpenInNew
            }, null, 8, ["icon"]),
            _createTextVNode(" " + _toDisplayString(_ctx.isPopoutPreviewVisible ? "Close" : "Popout") + " Preview ", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_divider)
      ]),
      _createVNode(_component_el_form, {
        "hide-required-asterisk": "",
        ref: "form",
        "label-position": "top",
        model: _ctx.signageLayout
      }, {
        default: _withCtx(() => [
          (_ctx.sortedLayoutZones.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_el_color_picker, {
                        modelValue: _ctx.signageLayout.globalBackgroundColor,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.signageLayout.globalBackgroundColor) = $event)),
                        onChange: _ctx.handleBackgroundColorChange,
                        "value-on-clear": '#00766A'
                      }, null, 8, ["modelValue", "onChange"]),
                      _hoisted_14
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createVNode(_component_el_color_picker, {
                        modelValue: _ctx.signageLayout.zoneBoundaryColor,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.signageLayout.zoneBoundaryColor) = $event)),
                        onChange: _ctx.handleZoneBoundaryColorChange,
                        "value-on-clear": '#414141'
                      }, null, 8, ["modelValue", "onChange"]),
                      _hoisted_16
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createVNode(_component_el_color_picker, {
                        modelValue: _ctx.signageLayout.globalFontColor,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.signageLayout.globalFontColor) = $event)),
                        onChange: _ctx.handleFontColorChange,
                        "value-on-clear": '#ffffff'
                      }, null, 8, ["modelValue", "onChange"]),
                      _hoisted_18
                    ])
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedLayoutZones, (zone) => {
                  return (_openBlock(), _createBlock(_component_el_collapse, {
                    key: zone.zoneNumber,
                    modelValue: _ctx.activeZones,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.activeZones) = $event))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_collapse_item, {
                        class: "signage-layout-zones",
                        title: _ctx.getZoneDisplayTitle(zone),
                        name: zone.zoneNumber
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            id: `editzone${zone.zoneNumber}`,
                            class: "signage-layout-zone"
                          }, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("div", _hoisted_21, [
                                (zone.zoneNumber != 1)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                      _createVNode(_component_el_form_item, {
                                        prop: "zoneType",
                                        class: "zone-type__selection"
                                      }, {
                                        default: _withCtx(() => [
                                          (zone.allowScrolling && zone.selectedZoneTypes && zone.selectedZoneTypes.includes('image'))
                                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, " Images cannot be combined with other content types in this zone. "))
                                            : (zone.allowScrolling)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Select one or more content types."))
                                              : _createCommentVNode("", true),
                                          _createVNode(_component_el_select, {
                                            ref_for: true,
                                            ref: `zoneTypeSelect_${zone.zoneNumber}`,
                                            placeholder: "Select content type",
                                            modelValue: zone.selectedZoneTypes,
                                            "onUpdate:modelValue": ($event: any) => ((zone.selectedZoneTypes) = $event),
                                            multiple: "",
                                            "multiple-limit": zone.allowScrolling ? 0 : 1 ,
                                            onChange: ($event: any) => (_ctx.updateZoneContent(zone))
                                          }, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zone.allowedZoneTypes, (zoneType) => {
                                                return (_openBlock(), _createBlock(_component_el_option, {
                                                  key: zoneType,
                                                  value: zoneType,
                                                  label: _ctx.getZoneTypeDisplayName(zoneType),
                                                  disabled: _ctx.isZoneTypeDisabled(zone, zoneType)
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.getZoneTypeDisplayName(zoneType)), 1)
                                                  ]),
                                                  _: 2
                                                }, 1032, ["value", "label", "disabled"]))
                                              }), 128))
                                            ]),
                                            _: 2
                                          }, 1032, ["modelValue", "onUpdate:modelValue", "multiple-limit", "onChange"])
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _hoisted_26,
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        plain: "",
                                        class: "mb-3",
                                        onClick: _ctx.toggleAssignSignageList
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" Add Signage Lists " + _toDisplayString(_ctx.currentlyAssignedListIds.length > 0 ? ` (${_ctx.currentlyAssignedListIds.length})` : ''), 1)
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"]),
                                      (_ctx.assignedSignageLists && _ctx.assignedSignageLists.length > 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                            _hoisted_28,
                                            _createVNode(_component_el_table, {
                                              data: _ctx.assignedSignageLists,
                                              "empty-text": "No lists assigned",
                                              style: {"width":"100%"}
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_table_column, {
                                                  label: "Name",
                                                  prop: "name"
                                                }, {
                                                  default: _withCtx((scope) => [
                                                    _createVNode(_component_router_link, {
                                                      to: `/signage/${scope.row.id}`,
                                                      class: "primary-color"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(scope.row.name), 1)
                                                      ]),
                                                      _: 2
                                                    }, 1032, ["to"])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }, 8, ["data"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])),
                                _createElementVNode("div", _hoisted_29, [
                                  (_ctx.zonesWithChanges.includes(zone.zoneNumber))
                                    ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                        key: 0,
                                        content: `Undo zone ${zone.zoneNumber} changes`,
                                        placement: "bottom-end",
                                        "hide-after": 0
                                      }, {
                                        default: _withCtx(() => [
                                          (_ctx.zonesWithChanges.includes(zone.zoneNumber))
                                            ? (_openBlock(), _createBlock(_component_el_button, {
                                                key: 0,
                                                type: "primary",
                                                circle: "",
                                                onClick: ($event: any) => (_ctx.onReset(zone))
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_Icon, {
                                                    icon: _ctx.mdiRefresh,
                                                    class: "dt-icon--large icon--white"
                                                  }, null, 8, ["icon"])
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ]),
                                        _: 2
                                      }, 1032, ["content"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_el_tooltip, {
                                    content: "Popout preview",
                                    placement: "bottom-end",
                                    "hide-after": 0
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        circle: "",
                                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.isPopoutPreviewVisible = !_ctx.isPopoutPreviewVisible))
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Icon, {
                                            icon: _ctx.mdiOpenInNew,
                                            class: "dt-icon--large icon--white"
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_tooltip, {
                                    content: "Scroll to top",
                                    placement: "bottom-end",
                                    "hide-after": 0
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_el_button, {
                                        type: "primary",
                                        circle: "",
                                        onClick: _ctx.scrollToTop
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_Icon, {
                                            icon: _ctx.mdiArrowUp,
                                            class: "dt-icon--large icon--white"
                                          }, null, 8, ["icon"])
                                        ]),
                                        _: 1
                                      }, 8, ["onClick"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              (zone && zone.zoneNumber != 1 && zone.selectedZoneTypes && zone.selectedZoneTypes.length > 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("div", _hoisted_31, [
                                      _hoisted_32,
                                      _createElementVNode("div", _hoisted_33, [
                                        _createVNode(_component_el_form_item, {
                                          class: "me-4",
                                          prop: "backgroundColor",
                                          label: "Background Color"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_el_color_picker, {
                                              class: "mt-1",
                                              modelValue: zone.backgroundColor,
                                              "onUpdate:modelValue": ($event: any) => ((zone.backgroundColor) = $event),
                                              onChange: (color) => _ctx.handleZoneBackgroundColorChange(color, zone),
                                              "value-on-clear": _ctx.getDefaultBackgroundColor()
                                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "value-on-clear"])
                                          ]),
                                          _: 2
                                        }, 1024),
                                        (!zone.selectedZoneTypes.includes('image'))
                                          ? (_openBlock(), _createBlock(_component_el_form_item, {
                                              key: 0,
                                              prop: "fontColor",
                                              label: "Font Color"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_el_color_picker, {
                                                  class: "mt-1",
                                                  modelValue: zone.fontColor,
                                                  "onUpdate:modelValue": ($event: any) => ((zone.fontColor) = $event),
                                                  onChange: (color) => _ctx.handleZoneFontColorChange(color, zone),
                                                  "value-on-clear": _ctx.getDefaultFontColor()
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange", "value-on-clear"])
                                              ]),
                                              _: 2
                                            }, 1024))
                                          : _createCommentVNode("", true)
                                      ])
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (zone && zone.selectedZoneTypes)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zone.selectedZoneTypes, (zoneType) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, { key: zoneType }, [
                                        (zone && zoneType && zone.zoneNumber != 1)
                                          ? (_openBlock(), _createBlock(_resolveDynamicComponent(zoneType), {
                                              key: 0,
                                              zoneContent: _ctx.getExistingContent(zone, zoneType),
                                              contentName: _ctx.getZoneTypeDisplayName(zoneType),
                                              zoneNumber: zone.zoneNumber,
                                              zoneType: zoneType,
                                              zoneHeight: zone.zoneHeight,
                                              zoneWidth: zone.zoneWidth,
                                              class: "signage-layout__zone-details w-100",
                                              onUpdateSignageZones: _ctx.updateSignageZones
                                            }, null, 40, ["zoneContent", "contentName", "zoneNumber", "zoneType", "zoneHeight", "zoneWidth", "onUpdateSignageZones"]))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ])
                          ], 8, _hoisted_19)
                        ]),
                        _: 2
                      }, 1032, ["title", "name"])
                    ]),
                    _: 2
                  }, 1032, ["modelValue"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["model"]),
      _createVNode(_component_DraggableModal, {
        title: "Signage Item Preview",
        modelValue: _ctx.isPopoutPreviewVisible,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isPopoutPreviewVisible) = $event))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              (_ctx.signageLayout)
                ? (_openBlock(), _createBlock(_component_SignageLayoutPreview, {
                    key: 0,
                    style: {"transform":"scale(0.3)","transform-origin":"top left"},
                    signageLayout: _ctx.signageLayout,
                    showEdit: false,
                    onZoneFocus: _ctx.zoneFocus
                  }, null, 8, ["signageLayout", "onZoneFocus"]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_37, [
              _createVNode(_component_Icon, {
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.isLightboxVisible = true)),
                class: "draggable-modal__fs-overlay-icon",
                icon: _ctx.mdiFullscreen
              }, null, 8, ["icon"])
            ])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.signageLayout)
        ? (_openBlock(), _createBlock(_component_Lightbox, {
            key: 0,
            "signage-layout": _ctx.signageLayout,
            modelValue: _ctx.isLightboxVisible,
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.isLightboxVisible) = $event))
          }, null, 8, ["signage-layout", "modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(_component_SignageListAssignmentModal, {
        visible: _ctx.isSignageListAssignmentModalVisible,
        "layout-name": _ctx.signageLayout.name,
        "signage-lists": _ctx.allSignageLists,
        "currently-assigned-list-ids": _ctx.currentlyAssignedListIds,
        loading: _ctx.isAssigningSignageList,
        onModalClosed: _cache[13] || (_cache[13] = ($event: any) => (_ctx.isSignageListAssignmentModalVisible = false)),
        onListSaved: _ctx.onSignageListAssigned
      }, null, 8, ["visible", "layout-name", "signage-lists", "currently-assigned-list-ids", "loading", "onListSaved"]),
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.isLayoutReplacementWarningVisible,
        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.isLayoutReplacementWarningVisible) = $event)),
        onClose: _ctx.onCancelLayoutReplacement,
        "custom-class": "signage__layout-replacement-warning-dialog"
      }, {
        title: _withCtx(() => [
          _hoisted_38,
          _createElementVNode("p", _hoisted_39, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listsWithDifferentLayouts.slice(0, 2), (item, index) => {
              return (_openBlock(), _createElementBlock("span", {
                key: item.list.id
              }, [
                _createTextVNode(_toDisplayString(item.list.name), 1),
                (index < _ctx.listsWithDifferentLayouts.slice(0, 2).length - 1)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(", ")
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
            }), 128)),
            (_ctx.listsWithDifferentLayouts.length > 2)
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  "show-after": 200,
                  placement: "bottom"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("ul", _hoisted_40, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listsWithDifferentLayouts.slice(2, _ctx.listsWithDifferentLayouts.length), (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: item.list.id
                        }, _toDisplayString(item.list.name), 1))
                      }), 128))
                    ])
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("span", null, " and " + _toDisplayString(_ctx.listsWithDifferentLayouts.length - 2) + " more.", 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        footer: _withCtx(() => [
          _createElementVNode("span", _hoisted_43, [
            _createVNode(_component_el_button, { onClick: _ctx.onCancelLayoutReplacement }, {
              default: _withCtx(() => [
                _createTextVNode("Cancel")
              ]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onConfirmLayoutReplacement
            }, {
              default: _withCtx(() => [
                _createTextVNode("Continue")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_41, [
            _createVNode(_component_Icon, {
              class: "icon icon--x-large icon--warning flex-shrink-0",
              icon: _ctx.mdiAlertCircle
            }, null, 8, ["icon"]),
            _hoisted_42
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "onClose"])
    ])), [
      [_directive_scroll_shadow]
    ])
  ])), [
    [_directive_loading, _ctx.signageLayoutLoading]
  ])
}